import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { SurveyAnswerRepositoryImpl } from "../../data/repository/survey_answer_repository_impl";
import { AnswerInterface } from "../interfaces/answer_interface";
import { SurveyInterface } from "../interfaces/survey_interface";

interface CreateAnswerProps {
    answer: AnswerInterface;
    surveyId: string;
}

export const useCreateAnswer = () => {
    const repository = new SurveyAnswerRepositoryImpl();
    const queryClient = useQueryClient();

    return useMutation<AnswerInterface | undefined, AxiosError, CreateAnswerProps>({
        mutationFn: ({ answer }) => repository.answerQuestion(answer),
        onSuccess: (newAnswer, { surveyId }) => {
            if (newAnswer) {
                queryClient.setQueryData<SurveyInterface | null>(['survey', surveyId], (old) => {
                    if (!old) return old;
                    const questions = old.questions.map(q =>
                        q.id === newAnswer.questionId ? { ...q, initialAnswer: newAnswer } : q
                    );
                    const nbPointsLeft = questions.filter(q => q.initialAnswer === undefined).length;
                    return { ...old, questions, nbPointsLeft, answered: nbPointsLeft === 0 };
                });
            }
            queryClient.invalidateQueries({ queryKey: ['surveysList'] });
            queryClient.invalidateQueries({ queryKey: ['surveyStatistics', surveyId] });
        },
    });
};
